<template>
  <SelectorWrapper
    :class="getSelectorStyling(selector.type)"
    class="pb-1"
  >
    <SelectorHeader
      :selector="selector"
      :reference="selector.reference"
      :title="selector.type"
      :display-delete="displayDelete"
    />
    <SelectorComposite
      v-if="isCompositeType(selector)"
      :reference="selector.reference"
      :selectors="selector.selectors"
    />
    <SelectorNot
      v-else-if="isNotType(selector)"
      :reference="selector.reference"
      :selector="selector"
    />
    <SelectorSubscribable
      v-else-if="isSubscribableType(selector)"
      :selector-reference="selector.reference"
      :selector="selector"
    />
    <SelectorSubscribableGrouping
      v-else-if="isSubscribableGroupingSelectorType(selector)"
      :selector-reference="selector.reference"
      :selector="selector"
    />
    <SelectorGroup
      v-else-if="isGroupSelectorType(selector)"
      :selector-reference="selector.reference"
      :selector="selector"
    />
    <SelectorMentor
      v-else-if="isMentorSelectorType(selector)"
      :selector-reference="selector.reference"
      :selector="selector"
    />
    <SelectorStudentCharacteristic
      v-else-if="isStudentCharacteristicType(selector)"
      :selector-reference="selector.reference"
      :selector="selector"
    />
  </SelectorWrapper>
</template>

<script>
import {
  isCompositeType,
  isGroupSelectorType,
  isMentorSelectorType,
  isNotType,
  isStudentCharacteristicType,
  isSubscribableGroupingSelectorType,
  isSubscribableType,
} from '@/employees/components/Selector/utilities/builder/selectorBuilder'
export default {
  name: 'SelectorTypeShow',
  props: {
    selector: {
      required: true,
      type: Object,
    },
    displayDelete: {
      required: false,
      type: Boolean,
      default: true,
    },
  },
  methods: {
    getSelectorStyling (selectorType) {
      switch (selectorType) {
        case 'composite':
          return 'composite'
        case 'not':
          return 'not'
        default:
          return ''
      }
    },
    isCompositeType (selector) {
      return isCompositeType(selector)
    },
    isNotType (selector) {
      return isNotType(selector)
    },
    isSubscribableType (selector) {
      return isSubscribableType(selector)
    },
    isSubscribableGroupingSelectorType (selector) {
      return isSubscribableGroupingSelectorType(selector)
    },
    isGroupSelectorType (selector) {
      return isGroupSelectorType(selector)
    },
    isMentorSelectorType (selector) {
      return isMentorSelectorType(selector)
    },
    isStudentCharacteristicType (selector) {
      return isStudentCharacteristicType(selector)
    },
  },
}
</script>

<style scoped>
.not {
  border-style: dashed;
  border-color: red;
  border-width: 1px;
}
.composite {
  border-left-style: solid;
  border-left-color: #006600;
}
.composite > .wrapper > .composite {
  border-left-color: #000099;
}
.composite > .wrapper > .composite > .wrapper > .composite {
  border-left-color:  #00b300;
}
.composite > .wrapper > .composite > .wrapper > .composite > .wrapper > .composite {
  border-left-color: #0000e6;
}
.composite > .wrapper > .composite > .wrapper > .composite > .wrapper > .composite > .wrapper > .composite {
  border-left-color: #00ff00;
}
.composite > .wrapper > .composite > .wrapper > .composite > .wrapper > .composite > .wrapper > .composite > .wrapper > .composite {
  border-left-color: #9999ff;
}
</style>
